module.exports = __webpack_public_path__ + "d9a2727d1554bcf3b3e72f67af294b5a.svg";